// components/TruncatedListModal.tsx
import React, { useState } from 'react';
import ClayLabel from '@clayui/label';
import ClaySticker from '@clayui/sticker';
import ClayButton from '@clayui/button';
import './TruncatedListModal.css'; // for styles

interface TruncatedListModalProps {
    items: string[];
    label: string;
    value: string;
    maxToShowItem?: number;
}

const TruncatedListModal: React.FC<TruncatedListModalProps> = ({ items, label, value, maxToShowItem = 3 }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const handleModalOpen = () => setIsModalVisible(true);
    const handleCloseModal = () => setIsModalVisible(false);

    const maxToShow = maxToShowItem;
    const displayed = items.slice(0, maxToShow);
    const remaining = items.length - maxToShow;

    return (
        <>
            <span>
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}
                >
                    {displayed.join(', ')}
                </span>
                {remaining > 0 && (
                    <ClayButton
                        className="more-label ml-1"
                        style={{ backgroundColor: 'white', padding: '0 6px' }}
                        onClick={handleModalOpen}
                    >
                        +{remaining}
                    </ClayButton>
                )}
            </span>

            {isModalVisible && (
                <div className="custom-modal-userDD">
                    <div
                        className="custom-modal-content-userDD"
                        style={{ maxHeight: '80vh', overflowY: 'auto' }}
                    >
                        <div className="modal-header">
                            <h1 className="managerTeam-sub-heading">{label}</h1>
                            <button
                                className="close-btn"
                                onClick={handleCloseModal}
                            >
                                ×
                            </button>
                        </div>
                        <div className="pt-4">
                            <span style={{ lineHeight: '24px' }}>{value}</span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TruncatedListModal;
